export enum ProgressType {
  LIVECLASSES,
  UNITS,
  PRACTICES,
}



// WEBPACK FOOTER //
// ./ts/app/shared/progress-type.ts